/**
 * Plan de mesure GA4 — 20 événements métier.
 *
 * Chaque fonction encapsule l'appel à `trackEvent` pour garantir un nommage
 * cohérent (action, category, label, value).
 */

import { trackEvent } from './googleAnalytics';

/* ---------- Recherche et navigation ---------- */

export const trackSearchSubmitted = (query: string) =>
  trackEvent('search_submitted', 'search', query);

export const trackSearchNoResult = (query: string) =>
  trackEvent('search_no_result', 'search', query);

export const trackFilterApplied = (filterName: string, filterValue: string) =>
  trackEvent('filter_applied', 'search', `${filterName}:${filterValue}`);

export const trackHashtagClicked = (hashtag: string) =>
  trackEvent('hashtag_clicked', 'search', hashtag);

export const trackRecentSearchClicked = (query: string) =>
  trackEvent('recent_search_clicked', 'search', query);

/* ---------- Consultation fiches ---------- */

export const trackActViewed = (libelle: string) =>
  trackEvent('act_viewed', 'cotation', libelle);

export const trackCotationPageViewed = (lettreCleValue: string) =>
  trackEvent('cotation_page_viewed', 'cotation', lettreCleValue);

export const trackLetterKeyPageViewed = (lettreCle: string) =>
  trackEvent('letter_key_page_viewed', 'cotation', lettreCle);

export const trackThemePageViewed = (themeSlug: string) =>
  trackEvent('theme_page_viewed', 'cotation', themeSlug);

export const trackRevalorisationsPageViewed = (year: string) =>
  trackEvent('revalorisations_page_viewed', 'cotation', year);

/* ---------- Simulateur (cœur business) ---------- */

export const trackSimulatorStarted = () =>
  trackEvent('simulator_started', 'simulator');

export const trackSimulatorActAdded = (libelle: string) =>
  trackEvent('simulator_act_added', 'simulator', libelle);

export const trackSimulatorActRemoved = (libelle: string) =>
  trackEvent('simulator_act_removed', 'simulator', libelle);

export const trackSimulatorParamsChanged = (paramName: string) =>
  trackEvent('simulator_params_changed', 'simulator', paramName);

export const trackSimulatorCompleted = (annualRevenue: number) =>
  trackEvent('simulator_completed', 'simulator', 'projection_rendered', Math.round(annualRevenue));

export const trackSimulatorPeriodSwitched = (period: string) =>
  trackEvent('simulator_period_switched', 'simulator', period);

export const trackSimulatorChartExported = () =>
  trackEvent('simulator_chart_exported', 'simulator', 'chart_image');

/* ---------- Engagement et acquisition ---------- */

export const trackShareLinkCopied = (pagePath: string) =>
  trackEvent('share_link_copied', 'share', pagePath);

export const trackArticleClicked = (articleTitle: string) =>
  trackEvent('article_clicked', 'engagement', articleTitle);

export const trackAppinesDeeplinkClicked = (sourcePage: string) =>
  trackEvent('appines_deeplink_clicked', 'conversion', sourcePage);
